import { render } from "./Cacheclear.vue?vue&type=template&id=24ef2b3e"
import script from "./Cacheclear.vue?vue&type=script&lang=js"
export * from "./Cacheclear.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__